import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { HelpCircleIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

export default function QuizItemNumberLabel(QuizItemNumberLabelProps: ComponentProps<'h5'>) {
  const { children, className, ...props } = QuizItemNumberLabelProps;
  return (
    <h5 className={cn('text-text-secondary flex flex-row items-center gap-1.5 text-sm', className)} {...props}>
      <Badge variant={'muted'} size={'sm'} className="p-1.5">
        <HelpCircleIcon />
      </Badge>
      {children}
    </h5>
  );
}
